import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface CustomDateRangeDialogData {
    startDate?: Date;
    endDate?: Date;
}

export interface CustomDateRangeDialogResult {
    startDate: Date;
    endDate: Date;
}

@Component({
    standalone: true,
    selector: 'app-custom-date-range-dialog',
    imports: [
    FormsModule,
    TranslateModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule
],
    templateUrl: './custom-date-range-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./custom-date-range-dialog.component.scss']
})
export class CustomDateRangeDialogComponent {
    startDate?: Date;
    endDate?: Date;

    constructor(
        private dialogRef: MatDialogRef<CustomDateRangeDialogComponent, CustomDateRangeDialogResult>,
        @Inject(MAT_DIALOG_DATA) data: CustomDateRangeDialogData
    ) {
        this.startDate = data?.startDate;
        this.endDate = data?.endDate;
    }

    isValid(): boolean {
        return !!(this.startDate && this.endDate && this.startDate <= this.endDate);
    }

    apply(): void {
        if (this.isValid() && this.startDate && this.endDate) {
            this.dialogRef.close({ startDate: this.startDate, endDate: this.endDate });
        }
    }

    cancel(): void {
        this.dialogRef.close();
    }
}
